var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{staticClass:"default",attrs:{"items":_vm.options,"item-text":"label","item-value":"value","background-color":"white","outlined":"","dense":"","multiple":"","hide-details":"","clearable":""},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }